import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import ReactDOM from 'react-dom';
import { Button } from 'antd';
import { IoClose } from 'react-icons/io5';
import { Z_OUTSIDE_PORTAL } from '../constants/ZIndex';

const ModalCloseButton = (props = { space: 30, onClose: () => { }, containerRef: null, zIndex: Z_OUTSIDE_PORTAL }, ref) => {
    const { onClose, space, zIndex } = props;
    const [el, setEl] = useState(null);

    useEffect(() => {
        const newEl = document.createElement('div');
        document.body.appendChild(newEl);
        setEl(newEl);

        return () => {
            document.body.removeChild(newEl);
        };
    }, []);

    useImperativeHandle(ref, () => {
        return {
            changePosition: () => { }
        }
    });

    if (!el) return null;

    return ReactDOM.createPortal(
        <Button style={{ zIndex: zIndex || Z_OUTSIDE_PORTAL, bottom: space ?? 30 }} tabIndex={1} className='right-[50%] rounded-full fixed modal-close-button' icon={<IoClose />} onClick={onClose} />,
        el
    );
};

export default forwardRef(ModalCloseButton);
